// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eservice-gpay-container {
  padding: 0;
}

.status-message {
  font-size: 13px;
  color: var(--ion-color-subtitle, #b0b0b0);
  margin: 0 0 12px;
  font-family: AppFont, sans-serif;
}

#eservice-google-pay-container {
  min-height: 48px;
}

.gpay-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  gap: 8px;
}
.gpay-spinner ion-spinner {
  color: var(--ion-color-primary);
}
.gpay-spinner p {
  margin: 0;
  font-size: 14px;
  font-family: AppFont, sans-serif;
  color: var(--ion-color-subtitle, #b0b0b0);
}`, "",{"version":3,"sources":["webpack://./src/app/components/eservice-google-pay/eservice-google-pay.component.scss"],"names":[],"mappings":"AAAA;EACC,UAAA;AACD;;AAEA;EACC,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,gCAAA;AACD;;AAEA;EACC,gBAAA;AACD;;AAEA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AACD;AACC;EACC,+BAAA;AACF;AAEC;EACC,SAAA;EACA,eAAA;EACA,gCAAA;EACA,yCAAA;AAAF","sourcesContent":[".eservice-gpay-container {\n\tpadding: 0;\n}\n\n.status-message {\n\tfont-size: 13px;\n\tcolor: var(--ion-color-subtitle, #b0b0b0);\n\tmargin: 0 0 12px;\n\tfont-family: AppFont, sans-serif;\n}\n\n#eservice-google-pay-container {\n\tmin-height: 48px;\n}\n\n.gpay-spinner {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tpadding: 16px 0;\n\tgap: 8px;\n\n\tion-spinner {\n\t\tcolor: var(--ion-color-primary);\n\t}\n\n\tp {\n\t\tmargin: 0;\n\t\tfont-size: 14px;\n\t\tfont-family: AppFont, sans-serif;\n\t\tcolor: var(--ion-color-subtitle, #b0b0b0);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
